import React, { useEffect, useRef, useState } from 'react';

// Generic multi-select dropdown styled like the FilterBar location picker.
// options: [{ id, label, sub? }]
export default function MultiDropdown({ icon, allLabel, options, selected, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);

  const toggle = (id) => {
    onChange(selected.includes(id) ? selected.filter(x => x !== id) : [...selected, id]);
  };

  const label = selected.length === 0
    ? allLabel
    : selected.length === 1
      ? (options.find(o => o.id === selected[0])?.label || allLabel)
      : `${selected.length} selected`;

  return (
    <div className="dd" ref={ref}>
      <button className="dd-btn" onClick={() => setOpen(o => !o)}>
        {icon} {label} <span style={{ fontSize: 9 }}>▼</span>
      </button>
      {open && (
        <div className="dd-panel">
          <div className="dd-actions">
            <button onClick={() => onChange(options.map(o => o.id))}>Check all</button>
            <button onClick={() => onChange([])}>Uncheck all</button>
          </div>
          {options.map(o => (
            <label key={o.id} className="dd-option">
              <input
                type="checkbox"
                checked={selected.includes(o.id)}
                onChange={() => toggle(o.id)}
              />
              {o.label}
              {o.sub && <span className="city">{o.sub}</span>}
            </label>
          ))}
          {options.length === 0 && <div className="empty">Nothing to select</div>}
        </div>
      )}
    </div>
  );
}
